exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "input[type=file]{display:none}.del{position:absolute;top:10px;right:10px}", "", {"version":3,"sources":["D:/xampp/htdocs/PhotoGenius_V2/src/components/bill_detail.vue"],"names":[],"mappings":"AACA,iBACE,YAAc,CACf,AACD,KACE,kBAAmB,AACnB,SAAU,AACV,UAAY,CACb","file":"bill_detail.vue","sourcesContent":["\ninput[type='file'] {\r\n  display: none;\n}\n.del {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c1da879","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bill_detail.vue
// module id = 313
// module chunks = 2